<template>
  <a
    role="button"
    @click.prevent.stop="toggleMode"
    tabindex="0">
    <span :class="{'text-muted': !flag, 'text-success': flag}">
      <i class="fa" :class="{'fa-check-circle': flag, 'fa-circle-o': !flag}"/>
      <small><b>{{ label }}</b></small>
    </span>
  </a>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
const BETA = 'beta'
const EDITOR = 'editor'

export default {
  name: 'AdminToggle',
  props: {
    flagType: {
      required: true,
      type: String,
      validator(value) {
        return [BETA, EDITOR].indexOf(value) > -1
      }
    }
  },
  computed: {
    ...mapState('visibility', ['betaMode', 'editorMode']),
    label() {
      if (this.flagType === BETA) {
        return 'BETA MODE'
      }
      if (this.flagType === EDITOR) {
        return 'EDITOR MODE'
      }
      return '(Undefined) Mode'
    },
    flag() {
      if (this.flagType === BETA) {
        return this.betaMode
      }
      if (this.flagType === EDITOR) {
        return this.editorMode
      }
    }
  },
  methods: {
    ...mapMutations('visibility', ['toggleBetaMode', 'toggleEditorMode']),
    toggleMode() {
      if (this.flagType === BETA) {
        this.toggleBetaMode(!this.betaMode)
      }
      if (this.flagType === EDITOR) {
        this.toggleEditorMode(!this.editorMode)
      }
    }
  }
}
</script>
